import { createEvent, createStore, restore, sample } from '@lib/state-engine';
import { warehouseModel } from '@entities/warehouse';
import { simpleMix } from '@entities/simple-mix';
import { IBag } from '@@/bags/ts';

const EMPTY_ITEM = { warehouseId: -1, bagId: '' };

export const mixBag = createEvent<{ bagId: IBag['id'] }>();
export const setBag = createEvent<{ id: string, idx: number }>();
export const unmixBag = createEvent<{ bagId: IBag['id'] }>();
export const removeBagCancel = createEvent();
export const removeBagConfirm = createEvent();
export const emptyBagCancel = createEvent();
export const emptyBagConfirm = createEvent();
export const removeBag = createEvent<{
  warehouseId: IBag['warehouseId'];
  bagId: IBag['id'];
}>();
export const emptyBag = createEvent<{
  warehouseId: IBag['warehouseId'];
  bagId: IBag['id'];
}>();

export const $removeBagConfirmation = createStore<{ [t: IBag['id']]: boolean }>(
  {},
).reset([removeBagConfirm, removeBagCancel]);

export const $emptyBagConfirmation = createStore<{ [t: IBag['id']]: boolean }>(
  {},
).reset([emptyBagConfirm, emptyBagCancel]);

const $emptyItem = restore(emptyBag, EMPTY_ITEM);
const $removeItem = restore(removeBag, EMPTY_ITEM);

sample({
  clock: emptyBag,
  fn: ({ bagId }) => ({ [bagId]: true }),
  target: $emptyBagConfirmation,
});

sample({
  clock: emptyBagConfirm,
  source: $emptyItem,
  target: [warehouseModel.clearWarehouseBag],
});

sample({
  clock: removeBag,
  fn: ({ bagId }) => ({ [bagId]: true }),
  target: $removeBagConfirmation,
});

sample({
  clock: removeBagConfirm,
  source: $removeItem,
  target: warehouseModel.removeWarehouseBag,
});

sample({
  clock: mixBag,
  fn: ({ bagId }) => bagId,
  target: simpleMix.addBag,
});

sample({
  clock: setBag,
  fn: (p) => p,
  target: simpleMix.addBagByIdx,
});

sample({
  clock: unmixBag,
  fn: ({ bagId }) => bagId,
  target: simpleMix.removeBag,
});
